import { render, staticRenderFns } from "./IconPauseSolid.vue?vue&type=template&id=bd8ac63a"
import script from "./IconPauseSolid.vue?vue&type=script&lang=js"
export * from "./IconPauseSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports